import { useCallback, useEffect, useState } from 'react';
import { BalancePaymentMethodsCardsApiResponse } from 'src/types/Balance';
import { fetchBalancePaymentMethodsCards as fetchBalancePaymentMethodsCardsFromApi } from 'src/components/selfService/common/Balance/api/fetchBalancePaymentMethodsCards';

export type UseFetchBalancePaymentMethodsCardsReturnType = {
  isLoading: boolean;
  hasError: boolean;
  balancePaymentMethodsCards: BalancePaymentMethodsCardsApiResponse | null;
  fetchBalancePaymentMethodsCards: () => Promise<void>;
};

export const useFetchBalancePaymentMethodsCards = (
  externalBalanceBuyerId: string | null
): UseFetchBalancePaymentMethodsCardsReturnType => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [balancePaymentMethodsCards, setBalancePaymentMethodsCards] =
    useState<BalancePaymentMethodsCardsApiResponse | null>(null);

  const fetchBalancePaymentMethodsCards =
    useCallback(async (): Promise<void> => {
      if (!externalBalanceBuyerId) {
        return;
      }

      try {
        setIsLoading(true);
        setHasError(false);

        const response = await fetchBalancePaymentMethodsCardsFromApi(
          externalBalanceBuyerId
        );
        setBalancePaymentMethodsCards(response);
      } catch (error) {
        setHasError(true);
      } finally {
        setIsLoading(false);
      }
    }, [externalBalanceBuyerId]);

  useEffect(() => {
    fetchBalancePaymentMethodsCards();
  }, [externalBalanceBuyerId, fetchBalancePaymentMethodsCards]);

  return {
    isLoading,
    hasError,
    balancePaymentMethodsCards,
    fetchBalancePaymentMethodsCards,
  };
};
